module.exports = __webpack_public_path__ + "img/chevron-down-20px-light.f56f18b.svg";